import React from 'react'
import Button from '@UI/antd/Button/Button'
import LoginBoxLineIcon from 'remixicon-react/LoginBoxLineIcon'
import SkipForwardFillIcon from 'remixicon-react/SkipForwardFillIcon'
import XArrowIcon from '@UI/XArrowIcon'
import styles from './index.scss'

interface IEventDetailsFooterMobile {
    hasSkip: boolean
    loading?: boolean
    isFinalStep?: boolean
    onNext: () => any
    onBack: () => any
    onLeave: () => any
    onSkip: () => any
    i18n?: any
    stepKey?: string
}

function EventDetailsFooterMobile(props: IEventDetailsFooterMobile) {
    const { onLeave, onNext, onBack, onSkip, hasSkip, i18n, loading = false, isFinalStep = false, stepKey } = props

    return (
        <div className={styles['event-details-footer-mobile']}>
            <div className={styles['event-details-footer-mobile__button']} onClick={onBack}>
                <XArrowIcon />
                {i18n?.General?.Back}
            </div>
            <div className={styles['event-details-footer-mobile__button']} onClick={onLeave}>
                <LoginBoxLineIcon />
                {!isFinalStep ? i18n?.extraKeys?.Save_And_Leave : i18n?.extraKeys?.Save}
            </div>
            {hasSkip && (
                <div className={styles['event-details-footer-mobile__button']} onClick={onSkip}>
                    <SkipForwardFillIcon />
                    {i18n?.extraKeys?.Skip}
                </div>
            )}
            <Button
                typeButton="secondary-ghost-icon"
                htmlType="submit"
                style={{ maxWidth: 'initial' }}
                className={styles['event-details-footer-mobile__button']}
                onClick={onNext}
                disabled={loading}
                loading={loading}
                id={`submit-${stepKey}`}
            >
                {!loading && <XArrowIcon thin reverse />}
                {i18n?.General?.Next}
            </Button>
        </div>
    )
}

export default EventDetailsFooterMobile
